import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) {
      setError("The two passwords don't match.");
      return;
    }
    setLoading(true);
    setError("");
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Your password has been updated.");
      nav("/signin");
    } catch (e) {
      setError(formatApiError(e.response?.data?.detail) || e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-5 py-10">
      <div className="w-full max-w-md">
        <div className="card-paper p-8 sm:p-10 paper-grain rise">
          <h1 className="font-serif-display text-3xl text-[#2C221E] leading-tight" data-testid="reset-title">
            Choose a new password
          </h1>
          <p className="mt-3 text-[#73635B]">A fresh key to the same quiet space.</p>

          {!token ? (
            <p className="mt-6 text-[#C26D53]">This reset link is missing a token. Please request a new one.</p>
          ) : (
            <form onSubmit={submit} className="mt-8 space-y-4">
              <div>
                <label className="text-xs uppercase tracking-widest text-[#8C7A70] font-semibold">
                  New password
                </label>
                <input
                  type="password"
                  className="input-paper mt-2"
                  minLength={6}
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  data-testid="reset-password-input"
                />
              </div>
              <div>
                <label className="text-xs uppercase tracking-widest text-[#8C7A70] font-semibold">
                  Confirm password
                </label>
                <input
                  type="password"
                  className="input-paper mt-2"
                  minLength={6}
                  required
                  value={confirm}
                  onChange={(e) => setConfirm(e.target.value)}
                  data-testid="reset-confirm-input"
                />
              </div>
              {error && <p className="text-sm text-[#C26D53]" data-testid="reset-error">{error}</p>}
              <button type="submit" disabled={loading} className="btn-primary w-full" data-testid="reset-submit">
                {loading ? "Saving…" : "Update password"}
              </button>
            </form>
          )}

          <div className="mt-6 text-sm text-[#52443E]">
            <Link to="/signin" className="text-[#C26D53] hover:underline" data-testid="reset-signin-link">
              Back to sign in
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
